import React from 'react';
import {get, has, noop} from 'lodash';

import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {Reports, SearchAndFilter} from '/constant/TestIDs';
import {RECORDS_FILTERS} from '/enum/filter.enum';
import {useTranslation} from '/provider/TranslationProvider';
import {getTextFromReactNode} from '/util/accessibility.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './FilterButton.style';
import {generateOnPress} from './FilterButton.util';
interface FilterButtonProps {
  navigate: () => void;
  recordsName: string;
  filterParams: Record<string, any>;
  setSelectedFilterParam: (param: any) => void;
  reportIsLoading: boolean;
}

// @ts-expect-error TS(7030): Not all code paths return a value.
export const FilterButton: React.FC<FilterButtonProps> = ({
  navigate = noop,
  recordsName = '',
  filterParams = {},
  setSelectedFilterParam = noop,
  reportIsLoading = false,
}) => {
  const {tt} = useTranslation('filterButton');
  const hasFilterSettings = has(RECORDS_FILTERS, recordsName, false);
  let buttonStyles = [styles.container];

  let filterKey = get(filterParams, 'key', '');

  const value = filterParams[recordsName] || {};

  const count =
    Object.keys(value).length === 0
      ? Object.keys(value).length
      : Object.keys(filterParams).length;

  const filterLabel =
    recordsName === 'SEARCH'
      ? tt(`filterBy-${filterKey}`, 'Filter')
      : tt(`filterBy-${filterKey}`, `Filters (${count})`);

  const isDisabled = reportIsLoading;
  if (isDisabled) {
    // @ts-expect-error TS(2345): Argument of type '{ opacity: number; }' is not ass... Remove this comment to see the full error message
    buttonStyles.push(styles.loading);
  }
  const buttonStyle = buttonStyles;

  if (hasFilterSettings) {
    return (
      <TouchableOpacity
        accessible={true}
        accessibilityLabel={getTextFromReactNode(filterLabel)}
        style={
          recordsName === 'SEARCH'
            ? styles.container
            : [styles.containerReport, buttonStyle]
        }
        onPress={generateOnPress({
          navigate,
          recordsName,
          setSelectedFilterParam,
          filterParams,
        })}
        {...testProperties(
          recordsName === 'SEARCH'
            ? SearchAndFilter.searchResultsFilterButton
            : Reports.reportFiltersBtn,
          true,
        )}>
        <Icon
          name="filter"
          style={recordsName === 'SEARCH' ? styles.icon : styles.iconReport}
        />
        <Text
          accessible={true}
          truncate
          style={recordsName === 'SEARCH' ? styles.text : styles.textReport}
          {...testProperties(
            recordsName === 'SEARCH'
              ? SearchAndFilter.searchResultsFilterButtonLabel
              : Reports.reportFiltersLabel,
          )}>
          {filterLabel}
        </Text>
      </TouchableOpacity>
    );
  }
};
